<template>
  <div>
    <div>
      <!--左边-->
      <div :style="[{height:screenHeight+'px'}]" class="one" style="overflow-x: hidden">
        <div :style="[{height:screenHeight+'px'}]"  style="overflow-y: scroll; width:228px">
          <div style="padding-top: 10px; width: 188px; text-align: center;">
            <img src="@/assets/logo.png" style="height:18px; margin-right: 2px; vertical-align: middle" />
            <span style="font-weight: bold; color: white; font-size: 13px;vertical-align: middle">【黑神话·悟空】-Z3</span>
          </div>
          <div style="text-align:left;padding:10px; color:white;border-top: 1px solid #576a81; margin-top: 15px;">
            <b>当前账户</b>
          </div>
          <div style="text-align:left;padding:10px; padding-top: 0px; color:white;">
            <input v-model="curAccount" style="background-color: #536780; width: 120px; color: white;padding: 10px 25px; border: 1px solid #233955;font-size: 12px;outline: none" />
          </div>
          <div style="text-align:left;padding:10px; padding-top: 0px; color:white;">
            <div>
              <input @click="setTopAccount" type="button" value="设置" style="outline: none; border: 0; border-radius: 3px; padding: 5px 25px; cursor:pointer; width: 170px; font-size: 12px; color: white;background-color: #8798ad;" />
            </div>

          </div>
          <div style="padding-top: 10px;">
            <!--子栏目-->
            <div @click="jumtToIndex()" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/0.png" style="height: 18px; vertical-align: middle" />
              首页
            </div>
            <div @click="openOrClose(1)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/1.png" style="height: 18px; vertical-align: middle" />
              用户管理
            </div>
            <div :style="{display:menuArray.one==0?'none':'','background-color':menuArray.oneColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('userList',1)" :style="{color:selectNum==1?'#ffffff':'#bfcbd9'}">
                用户列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('addDecreaseAmount',18989)" :style="{color:selectNum==18989?'#ffffff':'#bfcbd9'}">
                增减余额
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('filePhotoList',2)" :style="{color:selectNum==2?'#ffffff':'#bfcbd9'}">
                实名认证列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('bankList',2126)" :style="{color:selectNum==2126?'#ffffff':'#bfcbd9'}">
                用户银行卡
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('levelOrderList',2127)" :style="{color:selectNum==2127?'#ffffff':'#bfcbd9'}">
                升级奖励订单
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('friendList',2128)" :style="{color:selectNum==2128?'#ffffff':'#bfcbd9'}">
                好友列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('groupList',2129)" :style="{color:selectNum==2129?'#ffffff':'#bfcbd9'}">
                群列表
              </div>
            </div>

            <div @click="openOrClose(19)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/sc.png" style="height: 18px; vertical-align: middle" />
              积分商城
            </div>
            <div :style="{display:menuArray.ershi==0?'none':'','background-color':menuArray.ershiColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('addGood',9091)" :style="{color:selectNum==9091?'#ffffff':'#bfcbd9'}">
                添加商品
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('goodList',9192)" :style="{color:selectNum==9192?'#ffffff':'#bfcbd9'}">
                商品列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('orderList',91999)" :style="{color:selectNum==91999?'#ffffff':'#bfcbd9'}">
                兑换记录
              </div>
            </div>

            <div @click="openOrClose(2)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/2.png" style="height: 18px; vertical-align: middle" />
              项目管理
            </div>
            <div :style="{display:menuArray.two==0?'none':'','background-color':menuArray.twoColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('companyList',786)" :style="{color:selectNum==786?'#ffffff':'#bfcbd9'}">
                公司管理
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('stockList',3)" :style="{color:selectNum==3?'#ffffff':'#bfcbd9'}">
                股票列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('fundList',5)" :style="{color:selectNum==5?'#ffffff':'#bfcbd9'}">
                基金列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('futuresList',6)" :style="{color:selectNum==6?'#ffffff':'#bfcbd9'}">
                期货列表
              </div>
            </div>

            <div @click="openOrClose(8)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/currency.png" style="height: 18px; vertical-align: middle" />
              货币管理
            </div>
            <div :style="{display:menuArray.seven==0?'none':'','background-color':menuArray.sevenColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('currencyList',909)" :style="{color:selectNum==909?'#ffffff':'#bfcbd9'}">
                货币列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('currencyInvestList',919)" :style="{color:selectNum==919?'#ffffff':'#bfcbd9'}">
                货币购买记录
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('currencyWarOrderList',9199)" :style="{color:selectNum==9199?'#ffffff':'#bfcbd9'}">
                挑战记录
              </div>
            </div>

            <div @click="openOrClose(18)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/n1.png" style="height: 18px; vertical-align: middle" />
              黄金管理
            </div>
            <div :style="{display:menuArray.shier==0?'none':'','background-color':menuArray.shierColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('goldOrderList',9098)" :style="{color:selectNum==9098?'#ffffff':'#bfcbd9'}">
                黄金购买记录
              </div>
            </div>

            <div @click="openOrClose(3)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/3.png" style="height: 18px; vertical-align: middle" />
              财务管理
            </div>
            <div :style="{display:menuArray.three==0?'none':'','background-color':menuArray.threeColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('financeList',7)" :style="{color:selectNum==7?'#ffffff':'#bfcbd9'}">
                财务流水
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('investList',8)" :style="{color:selectNum==8?'#ffffff':'#bfcbd9'}">
                投资列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('issueList',158)" :style="{color:selectNum==158?'#ffffff':'#bfcbd9'}">
                发放记录
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('topUpList',10)" :style="{color:selectNum==10?'#ffffff':'#bfcbd9'}">
                充值管理（C）
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('topUpUsdtList',11)" :style="{color:selectNum==11?'#ffffff':'#bfcbd9'}">
                充值管理（U）
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('withDrawList',12)" :style="{color:selectNum==12?'#ffffff':'#bfcbd9'}">
                提现管理（C）
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('withDrawUsdtList',15)" :style="{color:selectNum==15?'#ffffff':'#bfcbd9'}">
                提现管理（U）
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('salaryList',151)" :style="{color:selectNum==151?'#ffffff':'#bfcbd9'}">
                工资记录
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('balanceWallet',152)" :style="{color:selectNum==152?'#ffffff':'#bfcbd9'}">
                余额宝记录
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('transferList',168)" :style="{color:selectNum==168?'#ffffff':'#bfcbd9'}">
                转账记录
              </div>
            </div>


            <div @click="openOrClose(5)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/8.png" style="height: 18px; vertical-align: middle" />
              数据统计
            </div>
            <div :style="{display:menuArray.frou==0?'none':'','background-color':menuArray.frouColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('platformDataTable',16)" :style="{color:selectNum==16?'#ffffff':'#bfcbd9'}">
                平台报表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('userDataTable',17)" :style="{color:selectNum==17?'#ffffff':'#bfcbd9'}">
                会员报表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('signList',171)" :style="{color:selectNum==171?'#ffffff':'#bfcbd9'}">
                签到记录
              </div>

            </div>

            <div @click="openOrClose(12)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/n2.png" style="height: 18px; vertical-align: middle" />
              短信群发
            </div>
            <div :style="{display:menuArray.shi==0?'none':'','background-color':menuArray.shiColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('createEmailAddressId',90999)" :style="{color:selectNum==90999?'#ffffff':'#bfcbd9'}">
                获取导出码
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('sendSms',909999)" :style="{color:selectNum==909999?'#ffffff':'#bfcbd9'}">
                短信群发
              </div>
            </div>
            <div @click="openOrClose(9)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/n5.png" style="height: 18px; vertical-align: middle" />
              抽奖管理
            </div>
            <div :style="{display:menuArray.eight==0?'none':'','background-color':menuArray.eightColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('awardList',801)" :style="{color:selectNum==801?'#ffffff':'#bfcbd9'}">
                奖品列表
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('awardOrderList',802)" :style="{color:selectNum==802?'#ffffff':'#bfcbd9'}">
                中奖记录
              </div>
            </div>
            <div @click="openOrClose(10)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/n6.png" style="height: 18px; vertical-align: middle" />
              红包雨管理
            </div>
            <div :style="{display:menuArray.night==0?'none':'','background-color':menuArray.nightColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('rerConfig',9801)" :style="{color:selectNum==9801?'#ffffff':'#bfcbd9'}">
                红包雨配置
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('rerNoteList',9802)" :style="{color:selectNum==9802?'#ffffff':'#bfcbd9'}">
                领取记录
              </div>
            </div>

            <div @click="openOrClose(6)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/5.png" style="height: 18px; vertical-align: middle" />
              文章管理
            </div>
            <div :style="{display:menuArray.five==0?'none':'','background-color':menuArray.fiveColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('newsList',18)" :style="{color:selectNum==18?'#ffffff':'#bfcbd9'}">
                文章列表
              </div>
            </div>

            <div @click="openOrClose(7)" style="padding: 15px; padding-left: 25px; font-size: 13px; color: #bfcbd9; text-align: left; cursor:pointer;">
              <img src="@/assets/home/6.png" style="height: 18px; vertical-align: middle" />
              系统设置
            </div>
            <div :style="{display:menuArray.six==0?'none':'','background-color':menuArray.sixColor}" style="background-color:#1f2d3d;padding:10px; display: none">
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('admin',19)" :style="{color:selectNum==19?'#ffffff':'#bfcbd9'}">
                账号管理
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('updatePwd',20)" :style="{color:selectNum==20?'#ffffff':'#bfcbd9'}">
                修改密码
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('systemBank',211)" :style="{color:selectNum==211?'#ffffff':'#bfcbd9'}">
                充值银行卡
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('levelList',212)" :style="{color:selectNum==212?'#ffffff':'#bfcbd9'}">
                等级配置
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('teamLevelList',215)" :style="{color:selectNum==215?'#ffffff':'#bfcbd9'}">
                团队等级配置
              </div>
              <div style="font-size: 12px; color: #bfcbd9; cursor: pointer; padding: 10px 0px 10px 39px" @click="jumpToPage('systemConfig',21)" :style="{color:selectNum==21?'#ffffff':'#bfcbd9'}">
                系统配置
              </div>
            </div>

          </div>
        </div>
      </div>
      <!--右上-->
      <div :style="[{width:screenWidth+'px'}]" class="two">
<!--        <div style="float: left; width: 100px; color: #bfcbd9; height: 60px; text-align: center; font-size: 16px; display: flex; align-items: center;justify-content: center; background-color: #304156;">-->
<!--          今日数据-->
<!--        </div>-->
        <div style="padding: 10px; padding-left: 15px; float: left;">
          <div style="color: #666666; vertical-align: middle">
            <img src="@/assets/home/a1.png" style="height: 15px; vertical-align: middle" />
            <span @click="jumpToPage('filePhotoList',2)" style="cursor:pointer">待审核身份:<b>{{ todayData.filePhotoNum }}</b></span>

            <img src="@/assets/home/a2.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span @click="jumpToPage('sendCardTopUp',800)" style="cursor: pointer;">待发卡充值:<b>{{ todayData.daifaka }}</b></span>

            <img src="@/assets/home/a1.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span @click="jumpToPage('topUpList',10)" style="cursor: pointer;">待审核充值:<b>{{todayData.waitAuditTopUp}}</b></span>

            <img src="@/assets/home/a5.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span style="margin-left: 0px;">今日充值:<b>{{todayData.successTopUp}}</b></span>
            <img src="@/assets/home/a5.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span style="margin-left: 0px;">今日充值(U):<b>{{ todayData.successTopUpUsdt }}</b></span>
          </div>
          <div style="padding-top: 5px; color: #666666; vertical-align: middle">
            <img src="@/assets/home/a1.png" style="height: 15px; vertical-align: middle;" />
            <span @click="jumpToPage('withDrawList',12)" style="cursor:pointer">待审核提现:<b>{{todayData.waitAuditWithDraw}}</b></span>

            <img src="@/assets/home/a1.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span @click="jumpToPage('withDrawUsdtList',15)" style="cursor: pointer;margin-left: 0px;">待审核提现(U):<b>{{todayData.waitAuditWithDrawUsdt}}</b></span>

            <img src="@/assets/home/a6.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span style="margin-left: 0px;">今日提现:<b>{{todayData.successWithDraw}}</b></span>
            <img src="@/assets/home/a6.png" style="height: 15px; vertical-align: middle;margin-left: 15px;" />
            <span style="margin-left: 0px;">今日提现(U):<b>{{todayData.successWithDrawPriceUsdt}}</b></span>

            <span style="margin-left: 15px;">撤单中:<b>{{todayData.investNum}}</b></span>
          </div>
        </div>
        <div style="float: right; width:180px; margin-left: 20px; padding-top:10px; overflow:hidden;">
          <img src="../assets/home/defaultImg.jpg" style="width: 35px; height: 35px; margin-top: 3px; float: left; border-radius: 6px; vertical-align: middle" />
          <div style="padding-left: 10px; float:left;">
            <span style="vertical-align: middle; color:#000000; font-size: 13px;" v-text="name"></span>
            <span @click="exit" style="vertical-align: middle; cursor:pointer; color:#2196f3; font-size: 13px;"> [退出]</span>
            <div style="padding-top:2px; font-size: 0">
              <div>
                <span style="color:#828282; font-size: 12px" v-text="time"></span>
              </div>
            </div>
          </div>
        </div>
        <div style="float: right; width: 520px; border-right:1px solid #ffffff; padding-bottom: 30px; padding-top:10px; overflow:hidden;">

        </div>
      </div>
      <!--右下-->
      <div :style="[{width:screenWidth+'px'},{height:(screenHeight-60)+'px'}]" style="overflow: hidden" class="iframe1">
        <div :style="[{width:screenWidth+18+'px'},{height:(screenHeight-30)+'px'}]" style="overflow: scroll">
          <component :is="currentComponent" @send="listenSend"></component>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import other from "../page/Index.vue"
import count from "../page/Count.vue"
import admin from "../page/system/AdminList.vue"
import addAdmin from "../page/system/AddAdmin.vue"
import updateAdmin from "../page/system/UpdateAdmin.vue"
import updatePwd from "../page/system/UpdatePwd.vue"
import systemConfig from "../page/system/SystemConfig.vue"
import addSystemConfig from "../page/system/AddSystemConfig.vue"
import updateSystemAdmin from "../page/system/UpdateSystemConfig.vue"
import newsList from "../page/news/NewsList.vue"
import addNews from "../page/news/AddNews.vue"
import updateNews from "./news/UpdateNews.vue"
import systemBank from "./system/SystemBank.vue"
import addSystemBank from "./system/AddSystemBank.vue"
import updateSystemBank from "./system/UpdateSystemBank.vue"
import levelList from "./system/LevelList.vue"
import addLevel from "./system/AddLevel.vue"
import updateLevel from "./system/UpdateLevel.vue"
import teamLevelList from "./system/TeamLevelList.vue"
import addTeamLevel from "./system/AddTeamLevel.vue"
import updateTeamLevel from "./system/UpdateTeamLevel.vue"
import userList from "./user/UserList.vue"
import addUser from "./user/AddUser.vue"
import updateUser from "./user/UpdateUser.vue"
import bankList from "./user/BankList.vue"
import filePhotoList from "./user/FilePhotoList.vue"
import financeList from "./finance/FinanceList.vue"
import investList from "./finance/InvestList.vue"
import issueListByInvestId from "./finance/IssueListByInvestId.vue"
import issueList from "./finance/IssueList.vue"
import salaryList from "./finance/SalaryList.vue"
import balanceWallet from "./finance/BalanceWallet.vue"
import signList from "./finance/SignList.vue"
import withDrawList from "./finance/WithDrawList.vue"
import withDrawUsdtList from "./finance/WithDrawUsdtList.vue"
import topUpUsdtList from "./finance/TopUpUsdtList.vue"
import transferList from "./finance/TransferList.vue"
import topUpList from "./finance/TopUpList.vue"
import sendCardTopUp from "./finance/SendCardTopUp.vue"
import platformDataTable from "./finance/PlatformDataTable.vue"
import userDataTable from "./finance/UserDataTable.vue"
import childUser from "./user/ChildUser.vue"
import stockList from "./project/StockList.vue"
import addStock from "./project/AddStock.vue"
import updateStock from "./project/UpdateStock.vue"
import addValue from "./project/AddValue.vue"
import breakProject from "./project/BreakProject.vue"
import fundList from "./project/FundList.vue"
import addFund from "./project/AddFund.vue"
import updateFund from "./project/UpdateFund.vue"
import addRate from "./project/AddRate.vue"
import futuresList from "./project/FuturesList.vue"
import addFutures from "./project/AddFutures.vue"
import updateFutures from "./project/UpdateFutures.vue"
import currencyList from "./currency/CurrencyList.vue"
import addCurrency from "./currency/AddCurrency.vue"
import updateCurrency from "./currency/UpdateCurrency.vue"
import currencyInvestList from "./currency/CurrencyInvestList.vue"
import companyList from "./project/CompanyList.vue"
import addCompany from "./project/AddCompany.vue"
import updateCompany from "./project/UpdateCompany.vue"
import addDecreaseAmount from "./user/AddDecreaseAmount.vue"
import bindBank from "./user/BindBank.vue"
import awardList from "./award/AwardList.vue"
import addAward from "./award/AddAward.vue"
import updateAward from "./award/UpdateAward.vue"
import awardOrderList from "./award/AwardOrderList.vue"
import updateAwardOrder from "./award/UpdateAwardOrder.vue"
import levelOrderList from "./user/LevelOrderList.vue"
import updateLevelOrder from "./user/UpdateLevelOrder.vue"
import rerConfig from "./rer/RerConfig.vue"
import addRerConfig from "./rer/AddRerConfig.vue"
import updateRerConfig from "./rer/UpdateRerConfig.vue"
import rerNoteList from "./rer/RerNoteList.vue"
import currencyWarOrderList from "./currency/CurrencyWarOrderList.vue"
import createEmailAddressId from "./email/CreateEmailAddressId.vue"
import goldOrderList from "./currency/GoldOrderList.vue"
import sendSms from "./email/SendSms.vue"
import friendList from "./user/FriendList.vue"
import groupList from "./user/groupList.vue"
import addGood from "./good/AddGood.vue"
import goodList from "./good/GoodList.vue"
import updateGood from "./good/UpdateGood.vue"
import orderList from "./good/OrderList.vue"
import updateOrder from "./good/UpdateOrder.vue"
import test from "./currency/Test.vue"
import {axiosGet} from "@/main";
import {DO_NET_URL, toask} from "@/config/config";
export default {
  name: "HomePage",
  data(){
    return{
      curAccount:"",
      screenHeight:0,
      screenWidth:0,
      url:"index.html",
      time:"当前时间",
      currentComponent: sendCardTopUp,
      name:"",
      selectNum:0,
      dsq:null,
      todayData:[],
      menuArray:{
        one:0,
        oneColor:"#1f2d3d",
        two:0,
        twoColor:"#1f2d3d",
        three:0,
        threeColor:"#1f2d3d",
        frou:0,
        frouColor:"#1f2d3d",
        five:0,
        fiveColor:"#1f2d3d",
        six:0,
        sixColor:"#1f2d3d",
        seven:0,
        sevenColor:"#1f2d3d",
        eight:0,
        eightColor:"#1f2d3d",
        night:0,
        nightColor:"#1f2d3d",
        shi:0,
        shiColor:"#1f2d3d",
        shier:0,
        shierColor:"#1f2d3d",
        ershi:0,
        ershiColor:"#1f2d3d",
      },
      daifaka:0,
    }
  },
  components: {
    other,count,admin,addAdmin,updateAdmin,updatePwd,systemConfig,addSystemConfig,updateSystemAdmin,
    newsList,addNews,updateNews,systemBank,addSystemBank,updateSystemBank,levelList,addLevel,updateLevel,
    teamLevelList,addTeamLevel,updateTeamLevel,userList,addUser,updateUser,bankList,filePhotoList,financeList,
    investList,issueListByInvestId,issueList,salaryList,balanceWallet,signList,withDrawList,withDrawUsdtList,
    topUpUsdtList,transferList,topUpList,sendCardTopUp,platformDataTable,userDataTable,childUser,stockList,addStock,
    updateStock,addValue,breakProject,fundList,addFund,updateFund,addRate,futuresList,addFutures,updateFutures,
    currencyList,addCurrency,updateCurrency,currencyInvestList,companyList,addCompany,updateCompany,addDecreaseAmount,
    bindBank,awardList,addAward,updateAward,awardOrderList,updateAwardOrder,levelOrderList,updateLevelOrder,rerConfig,
    addRerConfig,updateRerConfig,rerNoteList,currencyWarOrderList,createEmailAddressId,goldOrderList,sendSms,
    friendList,groupList,addGood,goodList,updateGood,orderList,updateOrder
  },
  beforeDestroy() {
    // 销毁前的处理逻辑
    console.log('页面即将销毁');
    clearInterval(this.dsq)
    this.dsq=null
  },
  mounted(){
    if(localStorage.getItem("topAccount")!=null&&localStorage.getItem("topAccount")!=""){
      this.curAccount=localStorage.getItem("topAccount")
    }
    let that=this
    if(localStorage.getItem("iwa_token")!=null&&localStorage.getItem("iwa_token")!=""){
      let _screenHeight=window.innerHeight;
      let _screenWidth=window.innerWidth;
      this.screenHeight=_screenHeight;
      this.screenWidth=_screenWidth-188;
      this.name=localStorage.getItem("name")
      var date=new Date();
      that.time=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
      setInterval(function (){
        var date=new Date();
        that.time=date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate()+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
      },1000)
      axiosGet(DO_NET_URL+"dataCount/TodayDataCount?topUser="+this.curAccount,function (res){
        res=res.data
        console.log(res)
        that.todayData=res
        let awaitSendCardNum=res.daifaka
        if(awaitSendCardNum>that.daifaka){
          that.playSound()
        }
        that.daifaka=awaitSendCardNum;
      })
      this.dsq=setInterval(function (){
        axiosGet(DO_NET_URL+"dataCount/TodayDataCount?topUser="+that.curAccount,function (res){
          res=res.data
          console.log(res)
          that.todayData=res
          let awaitSendCardNum=res.daifaka
          if(awaitSendCardNum>that.daifaka){
            that.playSound()
          }
          that.daifaka=awaitSendCardNum;
        })
      },5000)
    }else{
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }

  },
  methods: {
    setTopAccount(){
      localStorage.setItem("topAccount",this.curAccount)
      toask("设置成功！",6)
    },
    playSound() {
      const audio = new Audio('/static/2.mp3');
      audio.play()
          .then(() => {
            // 音频成功播放
          })
          .catch(err => {
            console.error(err);
            // 处理播放错误
          });
    },
    listenSend(data){
      console.log(data)
      this.currentComponent=data
    },
    openOrClose(index){
      if(index==1){
        this.menuArray.one=(this.menuArray.one==0?1:0)
      }else if(index==2){
        this.menuArray.two=(this.menuArray.two==0?1:0)
      }else if(index==3){
        this.menuArray.three=(this.menuArray.three==0?1:0)
      }else if(index==5){
        this.menuArray.frou=(this.menuArray.frou==0?1:0)
      }else if(index==6){
        this.menuArray.five=(this.menuArray.five==0?1:0)
      }else if(index==7){
        this.menuArray.six=(this.menuArray.six==0?1:0)
      }else if(index==8){
        this.menuArray.seven=(this.menuArray.seven==0?1:0)
      }else if(index==9){
        this.menuArray.eight=(this.menuArray.eight==0?1:0)
      }else if(index==10){
        this.menuArray.night=(this.menuArray.night==0?1:0)
      }else if(index==12){
        this.menuArray.shi=(this.menuArray.shi==0?1:0)
      }else if(index==18){
        this.menuArray.shier=(this.menuArray.shier==0?1:0)
      }else if(index==19){
        this.menuArray.ershi=(this.menuArray.ershi==0?1:0)
      }
    },
    jumtToIndex(){
      this.currentComponent=sendCardTopUp
      this.selectNum=0
    },
    exit(){
      if(confirm("确认退出系统吗？")){
        localStorage.setItem("iwa_token","")
        localStorage.setItem("permissions","")
        localStorage.setItem("name","")
        this.$router.replace('index')
      }
    },
    jumpToPage(page,num){
      this.currentComponent=page
      this.selectNum=num
    }
  }
}
</script>

<style scoped>
  .box-title{
    color: #000000; font-size: 36px;
    font-family:"siyuansongti";
  }
  #box{
    position: absolute; text-align: center; top: 0; left: 0; bottom:0; right: 0; z-index: 999; width:600px; height: 500px; margin: auto
  }
  .inputText{
    background-color: transparent; border: 0; outline: none; width:100%; font-size: 18px; color:#ffffff
  }
  .button1{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #2196f3; font-size: 18px; outline: none
  }
  .button1:hover{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #1a6cad; font-size: 18px; outline: none
  }
  .button1s{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #5d250b; font-size: 18px; outline: none
  }
  .button1s:hover{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #311305; font-size: 18px; outline: none
  }


  .button2{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #ffc107; font-size: 18px; outline: none
  }
  .button2:hover{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #ff9800; font-size: 18px; outline: none
  }
  .button2s{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #9e9e9e; font-size: 18px; outline: none
  }
  .button2s:hover{
    border: 0; padding:6px 25px 6px 25px; cursor:pointer; color: white; background-color: #797979; font-size: 18px; outline: none
  }


  .inputBack{
    background-color:#ba5a0d; width:360px; margin: auto; color: #ffffff; font-size: 18px; padding: 12px; border-radius:12px;
  }
  .oneType{
    text-align: right; cursor:pointer; padding: 12px 50px 12px 0; font-size: 15px; color:#525252
  }
  .one{
    width: 188px; box-shadow: 0 0 5px #00152959;  background-color: #304156; position:absolute; left: 0; top: 0; z-index: 999;
  }
  .oneType img{
    width: 18px; vertical-align: middle
  }
  .two{
    height:60px; box-shadow: 0 0 10px #e6e6e6;  background-color: #ffffff; position:absolute; left: 188px; top: 0; z-index: 998;overflow:hidden;
  }
  .iframe1{
    height:60px; border: 0; box-shadow: 0 0 10px #e6e6e6;  background-color:#ffffff; position:absolute; left: 188px; top:60px; z-index: 997;
  }
  .erji{
    text-align: right; cursor:pointer; padding: 12px 50px 12px 0; font-size: 12px; color:#7b7b7b
  }
</style>